import { Box, TextField } from "@mui/material";
import {
	EnhancedDropDownRHFWithLabel,
	EnhancedIOSSwitchRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect } from "react";

interface IPayrollPensionableEarningsDialogueSetupFieldsPanel {
	earningsList: any;
	selectedRecordData: any;
	formMethods: any;
}

export const PayrollPensionableEarningsDialogueSetupFieldsPanel: FC<
	IPayrollPensionableEarningsDialogueSetupFieldsPanel
> = ({ earningsList, selectedRecordData, formMethods }) => {
	useEffect(() => {
	
				if (selectedRecordData) {
		
			formMethods.setValue("id", selectedRecordData.id);
			formMethods.setValue("earningId", selectedRecordData.earningId);
			formMethods.setValue("province", selectedRecordData.province);
			formMethods.setValue("enable", 
				selectedRecordData.selectedProvinceObject.status === 100 ? true : false);
			formMethods.setValue(
				"effectiveDate",
				selectedRecordData.effectiveDate !== null &&
					selectedRecordData.effectiveDate !== ""
					? new Date(selectedRecordData.effectiveDate)
					: selectedRecordData.effectiveDate
			);
			formMethods.setValue(
				"endDate",
				selectedRecordData.endDate !== null && selectedRecordData.endDate !== ""
					? new Date(selectedRecordData.endDate)
					: selectedRecordData.endDate
			);
		}
	}, [selectedRecordData]);
	return (
		<>
			<TextField
				{...formMethods.register("id")}
				value={selectedRecordData.id}
				style={{ display: "none" }} // Hides the field
			/>
			<EnhancedDropDownRHFWithLabel
				label="Earning"
				selectName="earningId"
				testId={`earningId`}
				labelPosition={LabelPosition.Top}
				items={earningsList ?? []}
			/>
			<RHookFormTextFieldWithLabel
				id={"province"}
				testId={"province"}
				label={"Province"}
				readOnly={true}
			/>
			<EnhancedIOSSwitchRHFWithLabel
				name="enable"
				checked={false}
				testId="switch"
				label={"Enable"}
			/>
			<RHookFormDatePicker
				name="effectiveDate"
				testId="123"
				label="Effective Date"
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormDatePicker
				name="endDate"
				testId="123"
				label="End Date"
				labelPosition={LabelPosition.Top}
			/>
		</>
	);
};
